/* eslint-disable id-blacklist */

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as Types from './operations';

const defaultOptions = {};
export const FixtureFragmentDoc = gql`
  fragment Fixture on FootballFixture {
    id
    away {
      name
    }
    home {
      name
    }
    score {
      home
      away
    }
    duration {
      period
      status
      clock {
        minute
        second
        roundMinute
      }
    }
    status
    penaltyShootout {
      firstTeamToShoot
      penaltyFormat
      nextTeamToShoot
      penaltyScores {
        penaltyNumber
        side
        shotResult
      }
    }
  }
`;
export const MatchFragmentDoc = gql`
  fragment Match on TennisMatch {
    id
    teamAScore
    teamBScore
    currentSet {
      teamAScore
      teamBScore
      currentGame {
        teamAScore
        teamBScore
        teamServing
        type
      }
    }
    previousSets {
      teamAScore
      teamBScore
    }
    status {
      reason
      status
    }
  }
`;
export const FootballDocument = gql`
  query Football($eventIds: [ID!]!) {
    football {
      fixture(ids: $eventIds) {
        ...Fixture
      }
    }
  }
  ${FixtureFragmentDoc}
`;

/**
 * __useFootballQuery__
 *
 * To run a query within a React component, call `useFootballQuery` and pass it any options that fit your needs.
 * When your component renders, `useFootballQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFootballQuery({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useFootballQuery(
  baseOptions: Apollo.QueryHookOptions<Types.FootballQuery, Types.FootballQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.FootballQuery, Types.FootballQueryVariables>(
    FootballDocument,
    options
  );
}
export function useFootballLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.FootballQuery, Types.FootballQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.FootballQuery, Types.FootballQueryVariables>(
    FootballDocument,
    options
  );
}
export type FootballQueryHookResult = ReturnType<typeof useFootballQuery>;
export type FootballLazyQueryHookResult = ReturnType<typeof useFootballLazyQuery>;
export type FootballQueryResult = Apollo.QueryResult<
  Types.FootballQuery,
  Types.FootballQueryVariables
>;
export const TennisDocument = gql`
  query Tennis($eventIds: [ID!]!) {
    tennis {
      match(ids: $eventIds) {
        ...Match
      }
    }
  }
  ${MatchFragmentDoc}
`;

/**
 * __useTennisQuery__
 *
 * To run a query within a React component, call `useTennisQuery` and pass it any options that fit your needs.
 * When your component renders, `useTennisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTennisQuery({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useTennisQuery(
  baseOptions: Apollo.QueryHookOptions<Types.TennisQuery, Types.TennisQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.TennisQuery, Types.TennisQueryVariables>(TennisDocument, options);
}
export function useTennisLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.TennisQuery, Types.TennisQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.TennisQuery, Types.TennisQueryVariables>(
    TennisDocument,
    options
  );
}
export type TennisQueryHookResult = ReturnType<typeof useTennisQuery>;
export type TennisLazyQueryHookResult = ReturnType<typeof useTennisLazyQuery>;
export type TennisQueryResult = Apollo.QueryResult<Types.TennisQuery, Types.TennisQueryVariables>;
